"use strict";

let user_type_picker = $("input[name='user-type']");
let register_button = $('#btn_register');
let cancel_button = $('#cancel');

$(document).ready(function(){
    $('.selectpicker').selectpicker();
});

register_button.click(function(e) {
    e.preventDefault();
    switch ($("input[name='user-type']:checked").val()) {
        case "Job Seeker":
            window.location.href = "/job-seeker";
            break;
        case "Employer":
            window.location.href = "/employer";
            break;
    }
});

cancel_button.click(function(e) {
    e.preventDefault();
    window.location.href = "/";
});